<template>
  <div>
    <breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'审批采购订单'}]"/>
    <div class="h-content">
      <el-form :model="zy" label-position="right" ref="zy" :rules="rules" :inline="true"
               class="demo-ruleForm h-formbLine h-formbLine1">
        <div class="h-row h-mrt0">
          <div class="h-rowIn">
            <div class="h-rowBox">

              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>基本信息</h1>
                  </div>

                  <div class="h-pieceCon2">
                    <div class="h-formLine dingdan3">
                      <el-form-item label="销售订单号" class="h-elformWrap-2">
                        <el-input v-model="zy.orderCode" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="创建人" class="h-elformWrap-2">
                        <el-input v-model="zy.cuname" readonly></el-input>
                      </el-form-item>

                      <el-form-item label="创建时间" class="h-elformWrap-2">
                        <el-input v-model="zy.cdate" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="备注" class="h-elformWrap-2" prop="notes">
                        <el-input placeholder="请输入" v-model="zy.notes"></el-input>
                      </el-form-item>
                    </div>
                    <!-- 附件 v-if="this.orderType == '1'" -->
                    <div class="h-formLine dingdan3">
                      <el-form-item label="方案图纸" class="h-elformWrap-2" v-if="this.lkFlag">
                        <brupload
                            :refid=orderId
                            reftype="施工图纸"
                            :showtime="false"
                        >
                        </brupload>
                      </el-form-item>
                      <el-form-item label="施工确认单" class="h-elformWrap-2" v-if="this.lkFlag">
                        <brupload
                            :refid=orderId
                            reftype="NX_SGQRD"
                            :showtime="false"
                        >
                        </brupload>
                      </el-form-item>
                      <el-form-item label="海尔标准配置" class="h-elformWrap-2" v-if="this.lkFlag">
                        <brselect clearable category="haier_standard" :v="zy.isStandard" disabled="true"
                                  v-model="zy.isStandard"></brselect>
                      </el-form-item>
                      <el-form-item label="投标参数" class="h-elformWrap-2" v-if="this.lkFlag ">
                        <brupload
                            :refid=orderId
                            reftype="NX_TBCS"
                            :showtime="false"
                        >
                        </brupload>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <!-- <div class="h-pieceIn2">
                     <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                        <h1>产品信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine weekplandetail">
                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                <el-input  v-model="zy.productCateName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                <el-input  v-model="zy.productDes" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="产品单价" class="h-elformWrap-2">
                                <el-input  v-model="zy.unitPrice" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="产品数量" class="h-elformWrap-2">
                                <el-input  v-model="zy.count" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                <el-input  v-model="zy.totalPrice" readonly></el-input>
                            </el-form-item>

                        </div>
                    </div>
                </div> -->
                <div class="h-pieceIn2">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>物流信息</h1>
                  </div>
                  <div class="h-pieceCon2">
                    <div class="h-formLine dingdan3">
                      <el-form-item label="接收人" class="h-elformWrap-2">
                        <el-input v-model="zy.receiver" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="接收人手机号" class="h-elformWrap-2">
                        <el-input v-model="zy.receverPhone" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="收货单位" class="h-elformWrap-2">
                        <el-input v-model="zy.receiveUnit" readonly></el-input>
                      </el-form-item>
                      <el-form-item label="收货地址" class="h-elformWrap-2">
                        <el-input v-model="zy.detailAddress" style="width: 400px;" readonly></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="h-row h-mrt1">
          <div class="h-rowIn">
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-pieceIn2 mylyx">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->

                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>采购订单信息</h1>
                  </div>
                  <el-table
                      ref="multipleTable"
                      :data="zy.orderCgList"
                      border
                      style="width: 100%"
                  >
                    <el-table-column
                        type="index"
                        width="40"
                        label="#">
                    </el-table-column>
                    <el-table-column
                        prop="code"
                        label="采购订单号"
                        width="140">
                    </el-table-column>

                    <el-table-column
                        prop="suserCode"
                        label="供应商名称"
                        width="230">
                      <template scope="scope">
                        <el-select v-model="scope.row.suserCode"
                                   placeholder="选择"
                                   filterable
                                   clearable
                                   class="h-tableInput"
                                   v-if="!gsjFwFlag"
                                   @change="changeSup(scope.row.suserCode,scope.$index)"
                                   @clear="clearSelect(scope.row)"
                        >
                          <el-option
                              v-for="(item,index2) in options2[scope.$index]"
                              :key="index2"
                              :label="item.finalSupplierName"
                              :value="item.finalSupplier">
                          </el-option>
                        </el-select>
                        <el-input v-if="gsjFwFlag" v-model="scope.row.suserName" readonly v-else></el-input>
                        <!--<el-button type="danger" icon="el-icon-delete" size="mini" circle @click="clearSelect(scope.row)"></el-button>-->
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="expectDate"
                        label="期望到货时间"
                        width="150">
                      <template scope="scope">
                        <div class="block">
                          <el-date-picker
                              v-model="scope.row.expectDate"
                              type="date"
                              placeholder="--选择--"
                              value-format="yyyy-MM-dd"
                              class="h-tableInput">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                        min-width="150"
                        prop="hhxmCode"
                        :show-overflow-tooltip="true"
                        v-if="zy.factory == '1S00' || zy.factory == '1S40'"
                        label="项目合同">
                      <template slot-scope="scope">
                        <el-select class="h-tableInput"
                                   v-model="scope.row.hhxmCode"
                                   @change="changeHhxmCode(scope.row)"
                                   placeholder="请选择">
                          <el-option
                              v-for="item in hhxmList"
                              :key="item.id"
                              :label="item.contractName +'-'+ item.id"
                              :value="item.id">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="startTimeHhxm"
                        label="质保开始时间"
                        v-if="isHHxm"
                        :show-overflow-tooltip="true"
                        width="150">
                      <template slot-scope="scope">
                        <div class="block">
                          <el-date-picker
                              v-model="scope.row.startTimeHhxm"
                              @change="changeHhxmCode(scope.row)"
                              type="date"
                              :clearable="false"
                              value-format="yyyy-MM-dd">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="endTimeHhxm"
                        label="质保结束时间"
                        v-if="isHHxm"
                        :show-overflow-tooltip="true"
                        width="150">
                      <template slot-scope="scope">
                        <div class="block">
                          <el-date-picker
                              v-model="scope.row.endTimeHhxm"
                              @change="changeHhxmCode(scope.row)"
                              type="date"
                              :clearable="false"
                              value-format="yyyy-MM-dd">
                          </el-date-picker>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="waybillType"
                        label="物流类型"
                        width="150">
                      <template scope="scope">
                        <el-select v-model="scope.row.waybillType"
                                   placeholder="选择"
                                   filterable
                                   class="h-tableInput" @change="changeWuliu" disabled>
                          <el-option
                              v-for="(item) in options1[scope.$index]"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="beihuoflag"
                                     prop="beihuoId"
                                     label="关联备货单"
                                     width="150">
                      <template scope="scope">
                        <el-select v-model="scope.row.beihuoId"
                                   placeholder="选择"
                                   filterable
                                   class="h-tableInput">
                          <el-option
                              v-for="(item) in beihuolist"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="cgGroupCode"
                        label="采购组"
                        width="180">
                      <template scope="scope">
                        <mdmselect :showcode="true" clearable category="YLPurchaseGroup" disabled class="h-tableInput"
                                   :v="scope.row.cgGroupCode"
                                   v-model="scope.row.cgGroupCode"></mdmselect>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="purchaseOrgCode"
                        label="采购组织"
                        width="280">
                      <template scope="scope">
                        <desselect clearable category="purchase_org_code" :des="scope.row.factory"
                                   @change="changeCgGroup(scope.row)" class="h-tableInput"
                                   :v="scope.row.purchaseOrgCode"
                                   v-model="scope.row.purchaseOrgCode"></desselect>
                      </template>
                    </el-table-column>

                    <el-table-column
                        prop="productCateName"
                        label="产品大类"
                        :show-overflow-tooltip="true"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="productDes"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="150">
                      <template slot-scope="scope">
                        <div style="text-align: left;">
                          {{ scope.row.productDes }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="oemDesc"
                        label="规格型号"
                        :show-overflow-tooltip="true"
                        width="150">
                      <template slot-scope="scope">
                        <div style="text-align: left;">
                          {{ scope.row.oemDesc }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="unitPrice"
                        label="产品单价"
                        :show-overflow-tooltip="true"
                        width="100">
                      <template slot-scope="scope">
                        <div style="text-align: right;">
                          {{
                            scope.row.unitPrice = (scope.row.specialPrice != null ? scope.row.specialPrice : scope.row.unitPrice)
                          }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="currency"
                        label="币种"
                        width="110"
                        :show-overflow-tooltip="true">
                      <template slot-scope="scope">
                        {{ scope.row.currency | dictname('YLCurrency') }}
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="count"
                        label="产品数量"
                        :show-overflow-tooltip="true"
                        width="100">
                      <template slot-scope="scope">
                        <div style="text-align: right;">
                          {{ scope.row.count }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="specialPrice"
                        label="产品特价"
                        min-width="140"
                    >
                      <template slot-scope="scope">
                        <el-select
                            style="width: 100%;"
                            v-model="scope.row.specialOfferCode"
                            placeholder="请选择"
                            @change="changeTejia($event,scope.row)"
                            clearable>
                          <el-option
                              v-for="(item,index3) in scope.row.options2"
                              :key="index3"
                              :label="item.proDiscPrice"
                              :value="item.sid">
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="avaiNumber"
                        label="特价余量"
                        width="130">
                      <template slot-scope="scope">
                        <el-input readonly placeholder="自带出"
                                  v-model="scope.row.avaiNumber"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="totalPrice"
                        label="产品总价"
                        :show-overflow-tooltip="true"
                        width="100">
                      <template slot-scope="scope">
                        <div style="text-align: right;">
                          {{ scope.row.totalPrice }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="yremark"
                        label="备注"
                        :show-overflow-tooltip="true"
                        width="100">
                      <template slot-scope="scope">
                        <div style="text-align: left;">
                          {{ scope.row.yremark }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="h-row h-mrt1">
          <div class="h-rowIn">
            <div class="h-rowBox">
              <div class="h-rowCon">
                <div class="h-pieceIn2 mylyx">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                  <div class="h-pieceTitle2" style="margin: 0.3rem 0;margin-top: 0;">
                    <h1>审核信息</h1>
                  </div>
                  <div class="h-pieceCon2 ">
                    <div class="h-formLine dingdan3" style="position: relative;">
                      <el-form-item label="审批意见" class="h-elformWrap-2 newBox" :required="true"
                                    style="width: 100%!important;">
                        <el-input v-model="zy.des" placeholder="请输入"></el-input>
                      </el-form-item>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </el-form>
      <div class="apprButton">
        <el-button v-if="taskstatus==1" class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
        <el-button v-if="taskstatus==0" class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
        <!--              //   orderCategory1-->
        <!--              // 工程订单("1","", "工程订单"),-->
        <!--              //     标准订单_内销("2","","标准订单"),-->
        <!--              //     免费订单_内销("6","","免费订单"),-->
        <!--              //     特价订单_内销("11","","特价订单_内销"),-->
        <!--              //     外贸订单_外销("26", "", "外贸订单"),-->
        <!--                <el-button v-if="taskstatus==0&&(zy.orderId==null||zy.orderCategory1 == 1||zy.orderCategory1 == 2||zy.orderCategory1 == 6||zy.orderCategory1 == 11||zy.orderCategory1 == 26)"  class="h-btn h-bBtn h-bgred" @click="refuse">驳回</el-button>-->
        <el-button v-if="taskstatus==0" class="h-btn h-bBtn h-bggreen" @click="pass">通过</el-button>
        <el-button class="h-btn h-bBtn" @click="viewpress">
          审批跟踪
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
  </div>
</template>

<script>
import ss from '../../api/SystemService'
import util from "../../utils/util"
import big from 'big.js'

export default {
  data() {
    return {
      beihuoflag: false,
      beihuolist: [],
      //带线表单
      value: false,
      showhistory: false,
      isHHxm: false,
      orderId: this.$route.query.ywid,
      instid: this.$route.query.instid,
      taskId: this.$route.query.taskid,
      link: this.$route.query.link || '',
      options1: [],
      options2: [],
      hhxmList: [],
      zy: {
        des: '',
      },
      vs: {
        productId: ""
      },
      rules: {
        suserCode: [
          {required: true, message: '请选择供应商名称', trigger: 'blur'}
        ],
        expectDate: [
          {required: true, message: '请选择期货时间', trigger: 'change'},
        ],
        waybillType: [
          {required: true, message: '请选择物流类型', trigger: 'change'}
        ],
        cgGroupCode: [
          {required: true, message: '请选择采购组', trigger: 'change'}
        ],
      },
      taskstatus: this.$route.query.taskstatus,
      lkFlag: false,
      csFlag: false,
      lkOrderId: null,
      priceData: {
        finalSupplier: null,
        productId: null,
      },
      gsjFwFlag:false,
    }
  },
  methods: {
    changeWuliu(data) {
      if (data == '3') {
        this.beihuoflag = true;
      } else {
        this.beihuoflag = false;
      }
    },
    cancel() {
      if (this.link == 0) {
        this.$router.push("/personal/dealCenter");
      } else if (this.link == 1) {
        this.$router.push("/dingd/purchaselistNx");
      } else if (this.link == 2) {
        this.$router.push("/dingd/purchaselistWx");
      } else if (this.link == 3) {
        this.$router.push("/dingd/purchaselist");
      } else {
        this.$router.push("/personal/dealCenter");
      }
    },
    clearSelect(row) {
      console.log(row)
      row.suserCode = null;
      row.suserName = null;
      row.proId = null;
      row.unitPrice = 0;
      row.unitPriceE = 0;
      row.totalPrice = 0;
      row.specialPrice = null;
      row.specialOfferCode = null;
      row.currency = null;
    },
    refuse() {
      if (this.zy.orderId == null) {

        this.zy.orderCgList.forEach((item, index) => {
          this.zy.orderCgList[index].expectDate = util.riQi6(this.zy.orderCgList[index].expectDate)
        })
        if (this.zy.expectDate) {
          this.zy.expectDate = util.riQi6(this.zy.expectDate)
        }
        ss.orderCgService.approveFail(this.zy).then(rd => {
          if (rd.f) {
            this.$msg.msgs(rd.msg);
            this.$store.dispatch('searchTasktotal');
            this.$router.push("purchaselist");
          } else {
            this.$msg.msgs("审批失败！" + rd.msg);
          }
        })
      } else {
        var spform = {}
        spform.optflag = '驳回'
        if (!this.zy.des) {
          this.$msg.msge("驳回必须输入审批意见！");
          return;
        }
        spform.shouyiarea = null;
        spform.shpyj = this.zy.des;
        spform.taskid = this.zy.taskId;
        spform.taskstatus = null;
        spform.ywid = this.zy.orderId
        spform.orderMainProductList = [];
        this.zy.orderCgList.forEach((item, index) => {
          var productObj = {};
          productObj.id = this.zy.orderId;
          spform.orderMainProductList.push(productObj)
        })
        ss.OrderMainService.shpsaveOrSubmit(spform).then(rd => {
          if (rd.f) {
            this.$msg.msgs(rd.msg);
            this.$store.dispatch('searchTasktotal');
            this.$router.push("purchaselist");
          } else {
            this.$msg.msgs("审批失败！" + rd.msg);
          }
        })

      }
    },
    pass() {
      var msg = [];

      this.zy.orderCgList.forEach((item, index) => {
        if (item.suserCode == null || item.suserCode == "") msg.push("供应商");
        if (item.expectDate == null || item.expectDate == '') msg.push("期望到货时间");
        if (item.waybillType == null || item.waybillType == "") msg.push("物流类型");
        if (item.cgGroupCode == null || item.cgGroupCode == "") msg.push("采购组");
        if (item.purchaseOrgCode == null || item.purchaseOrgCode == "") msg.push("采购组织");
        if (item.expectDate != null && item.expectDate != '') {
          item.expectDate = util.riQi6(item.expectDate);
        }
      })
      if (msg.length > 0) {
        msg = _.uniq(msg);
        this.$msg.msge("请选择" + msg.join("、") + "。");
        return;
      }

      ss.orderCgService.approveSuccess(this.zy).then(rd => {
        if (rd.f) {
          this.$msg.msgs(rd.msg);
          this.$store.dispatch('searchTasktotal');
          if (this.link == 0) {
            this.$router.push("/personal/dealCenter");
          } else if (this.link == 1) {
            this.$router.push("/dingd/purchaselistNx");
          } else if (this.link == 2) {
            this.$router.push("/dingd/purchaselistWx");
          } else if (this.link == 3) {
            this.$router.push("/dingd/purchaselist");
          } else {
            this.$router.push("/personal/dealCenter");
          }
        } else {
          this.$msg.msgs("审批失败！" + rd.msg);
        }
      })
    },
    //供应商名字
    changeSup(v, i) {
      // this.options1[i] = [];

      this.options2[i].forEach((item, index) => {

        if (this.zy.orderCgList[i].suserCode == item.finalSupplier) {

          this.zy.orderCgList[i].suserName = item.finalSupplierName;
          this.zy.orderCgList[i].proId = item.contractId;
          this.zy.orderCgList[i].unitPrice = item.unitPrice;
          this.zy.orderCgList[i].totalPrice = new big(item.unitPrice).times(this.zy.orderCgList[i].count).toFixed(2).toString();
          this.zy.orderCgList[i].currency = item.currency;

						//如果是上海天满 产品价格取销售订单的75折
						if(this.zy.orderCgList[i].suserCode == "V96180"){
							//查询销售订单价格
							var data = this.zy.orderId;
							ss.OrderMainService.getOrderFinalPriceBySapcode(data).then(rd => {
								this.zy.orderCgList[i].unitPrice = rd.msg * 0.75;
								this.zy.orderCgList[i].totalPrice = new big(this.zy.orderCgList[i].unitPrice).times(this.zy.orderCgList[i].count).toFixed(2).toString();
							})
						}

          //                if (item.wuliufangshi == 3) {
          //                    this.options1[i] = this.$store.getters.dicts["waybill_type"];
          //                }else{
          //                    this.options1[i] = [{"code": item.wuliufangshi,"name":this.$store.getters.dictname("waybill_type",item.wuliufangshi)},
          // {"code":"3","name":this.$store.getters.dictname("waybill_type",3)}];
          //                }
          console.log("this.priceData", item);
          this.priceData.finalSupplier = item.finalSupplier;
          this.priceData.productId = item.productId;
          //调用接口获取特价信息
          ss.orderCgService.getPriceBySupplier(this.priceData).then(rd => {
            if (rd.f) {
              this.zy.orderCgList[i].options2 = rd.msg;
            }
          })


        }
      })
    },
    viewpress(r) {
      this.showhistory = true;
    },

    //特价改变
    changeTejia(scode, row) {
      console.log('特价改变', scode, row)
      if (row.specialOfferCode) {
        const tjobj = _.find(row.options2, {sid: row.specialOfferCode})
        row.specialPrice = tjobj.proDiscPrice;
        row.specialPrice = tjobj.proDiscPrice;
        row.avaiNumber = tjobj.avaiNumber;
        row.unitPrice = tjobj.proDiscPrice;
        row.totalPrice = new big(row.unitPrice).times(row.count).toFixed(2);
        row.sid = tjobj.sid;
      } else {
        row.specialPrice = null;
        row.specialOfferCode = null;
        row.specialPrice = null;
        row.avaiNumber = null;
        row.unitPrice = 0;
        row.totalPrice = 0;
        row.sid = null;
      }
    },
    //根据采购组织获取采购组
    changeCgGroup(v) {
      var category = 'cg_org_group';
      var code = v.purchaseOrgCode;
      //根据选中的采购组织编码获取采购组
      ss.Dictservice.getDictByCateCode(category, code).then(rd => {
        this.zy.cgGroupCode = rd.name;
      })
    },
    changeHhxmCode(value) {
      console.log(value)
      this.isHHxm = true;
      this.zy.hhxmCode = value.hhxmCode;
      this.zy.startTimeHhxm = value.startTimeHhxm;
      this.zy.endTimeHhxm = value.endTimeHhxm;
    },

  },
  mounted() {
    if (this.instid != null) {

      //查看订单详情
      ss.orderCgService.selectByInstid(this.instid).then(rd => {
        //初始化默认数据
        console.log(rd, "采购订单详情")
        this.zy = rd.obj
        if (this.zy) {
          //初始化供应商下拉框
          // var i= 0;
          // var vs = this.vs;
          // var cl = this;
          // _.forEach(this.zy.orderCgList,function(item){
          //     console.log(item)
          //                              //获取供应商列表
          //     if (item.productNo) {
          //         vs.productId = item.productNo;
          //         ss.ProService.supplierByProductId(vs).then(rd => {
          //             if (rd && rd.length > 0) {
          //                 cl.options2[i] = rd;
          //                 cl.$set(this.options2,i, rd);
          //
          //             }
          //         })
          //
          //     }
          //     i++;
          //
          // })

          //如果销售订单号是HSW开头，给供应商下拉框赋值
          if(this.zy.orderCode.indexOf("HSW") > -1){
                this.gsjFwFlag = true;
          }

            for (var i = 0; i < this.zy.orderCgList.length;) {
            var item = this.zy.orderCgList[i];
            //获取供应商列表
            if (item.productNo && !this.gsjFwFlag) {
              // this.vs.productId = this.zy.productNo;
              ((i, productNo) => {
                ss.ProService.supplierByProductId({productId: productNo}).then(rd => {
                  if (rd && rd.length > 0) {
                    this.options2[i] = rd;
                    this.$set(this.options2, i, rd);
                  }
                })
              })(i, item.productNo)
              this.changeWuliu(item.waybillType);
              item.suserCode = null;
              item.unitPrice = 0;
            }
            // if (this.taskstatus == 1) {
            this.options1[i] = this.$store.getters.dicts["waybill_type"];
            // }
            i++;

          }

          console.log("this.zy.orderCgList", this.zy.orderCgList);
          console.log("this.zy", this.zy);
          //如果1S00公司
          if ((this.zy.factory == '1S00' || this.zy.factory == '1S40') && this.hhxmList.length == 0) {
            //查询厚宏项目合同
            ss.contractService.selectByCodeHhxm(this.zy.orderId).then(rd => {
              console.log("rdrdrdrdrd", rd)
              if (rd.obj.ccode != null && rd.obj.ccode != '') {
                this.isHHxm = true;
                this.zy.orderCgList.forEach((item, index) => {
                  this.zy.orderCgList[index].hhxmCode = rd.obj.ccode;
                  this.zy.orderCgList[index].startTimeHhxm = rd.obj.startTime;
                  this.zy.orderCgList[index].endTimeHhxm = rd.obj.endTime;
                })
                this.zy.hhxmCode = rd.obj.hhxmCode;
                this.zy.startTimeHhxm = rd.obj.startTime;
                this.zy.endTimeHhxm = rd.obj.endTime;
              }
            })
          }

          if (this.zy.des) {
            this.zy.des = ''
          }
          // console.log(this.zy.des);
          if (typeof (this.zy.des) != "undefined" && '' != this.zy.des) {
            this.$set(this.zy.des, '');
          }
          this.zy.taskId = this.taskId;
          //判断是否是冷库产品
          ss.waixiao.isLk(rd.obj.productNo).then(rd => {
            this.lkFlag = rd.msg;
            console.log("lkFlag", this.lkFlag)
          })
          //判断是否海尔标准
          if (rd.obj.orderCode) {
            var data = rd.obj.orderCode;
            ss.OrderMainService.checkStandard(data).then(rd => {
              if (rd.msg == 1) {
                this.zy.isStandard = rd.msg;
              } else if (rd.msg == 2) {
                this.zy.isStandard = rd.msg;
                this.csFlag = true;
              }
            })
            //获取主表id
            var data = this.$route.query.ywid;
            ss.OrderMainService.getOrderId(data).then(rd => {
              this.lkOrderId = rd.msg;
            })
          }
        }
      })
    }
    ;
    ss.orderCgService.getBeihuoList().then(rd => {
      this.beihuolist = rd;
    })
  },
  created() {
    // this.options1 = this.$store.getters.dicts["waybill_type"];
  }

}
</script>

<style scoped>
.passfollow {
  position: absolute;
  right: 0;
  bottom: 0.4rem;
  background-color: #2785e7;
  color: white;
}

.h1 {
  margin: 20px 0 0 31px;
}

.bbbb {
  background-color: white;
  padding-bottom: 30px;
}

.apprButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.3rem 0;
}

.cancel {
  width: 18%;
}

.pass {
  background-color: #006aca;
  color: white;
  width: 18%;
}

.refuse {
  background-color: #24b5b8;
  color: white;
  width: 18%;
}
</style>
<style>
.mylyx .el-table tbody td .cell {
  padding: 0.08rem;
}

.mylyx .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}

.mylyx .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}

.dingdan3.h-formLine .el-form-item__label {
  width: 31%;
  text-align: right;
}

.dingdan3.h-formLine .newBox .el-form-item__label {
  width: 9.7%;
  text-align: right;
}

.dingdan3.h-formLine .el-form-item__content {
  width: 69%;
}

.dingdan3.h-formLine .newBox .el-form-item__content {
  width: 90.3%;
}

.dingdan3.h-formLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem
}

.dingdan1.h-formLine .h-elformWrap-4 {
  width: 66%;
  padding-right: 0.5rem
}

.dingdan1.h-formLine .h-elformWrap-4 .el-form-item__label {
  width: 17%;
  text-align: right;
}
</style>
